import { composeClasses } from '@wiggot/utils/src/strings'
import MonopolioBrand from './MonopolioBrand'

interface PoweredByMonopolioProps {
  light?: boolean
}

const PoweredByMonopolio = ({
  light,
}: PoweredByMonopolioProps): JSX.Element => {
  return (
    <div className="flex items-center gap-1 h-max">
      <span
        className={composeClasses(
          'text-sm mb-[2px]',
          light ? 'text-primary' : 'text-[#726E7D]'
        )}
      >
        por
      </span>
      <MonopolioBrand light={true} />
    </div>
  )
}

export default PoweredByMonopolio
